import { render } from "./ManageUserView.vue?vue&type=template&id=523ee650"
import script from "./ManageUserView.vue?vue&type=script&lang=js"
export * from "./ManageUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__